import getAccountProperties from './getAccountProperties'

export default function isEnterpriseAdmin() {
  const { enterpriseAdmin } = getAccountProperties()

  return enterpriseAdmin
}
